import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Tooltip } from 'shared/ui'
import {
  type IInputNumericProps,
  InputNumeric,
  makeTextFieldIcon,
  TextField,
} from 'shared/ui/TextField'
import { SchedulePeriod } from 'shared/ui/Schedule/ui/SchedulePeriod'
import { type ISchedulePeriodProps } from 'shared/ui/Schedule/ui/SchedulePeriod/SchedulePeriod'
import styles from './styles.module.scss'
import { useScheduleDelayContext } from '../context/sendLaterContext'

export type IScheduleDateFiledUIProps = {
  dropdownId: string
  excludePeriods?: ISchedulePeriodProps['excludePeriods']
}

export const ScheduleDelayUI = observer(
  ({ dropdownId, excludePeriods }: IScheduleDateFiledUIProps) => {
    const { waitValue, setWaitValue, schedulePeriodStore, handleValidate, setLastValidValue } =
      useScheduleDelayContext()

    const [isHideTooltip, setHideTooltip] = useState(false)

    const onFocus = () => {
      if (Number(waitValue)) {
        setLastValidValue(waitValue)
      }
      setHideTooltip(true)
    }

    const onBlur = () => {
      handleValidate()
      setHideTooltip(false)
    }

    useEffect(() => {
      return handleValidate
    }, [])
    return (
      <div className={styles.wrap}>
        <Tooltip label={'Wait'} placement='left' visibility={isHideTooltip ? 'hidden' : undefined}>
          <TextField
            size={'small'}
            variant={'outline'}
            leftActions={[
              makeTextFieldIcon({
                icon: 'sandGlasses',
                className: styles.wrapIcon,
              }),
            ]}
            Input={InputNumeric}
            value={waitValue}
            onChange={setWaitValue}
            InputProps={
              {
                maxLength: 3,
                allowNegative: false,
                decimalScale: 0,
              } as IInputNumericProps
            }
            onFocus={onFocus}
            onBlur={onBlur}
            className={styles.input}
          />
        </Tooltip>

        <SchedulePeriod
          store={schedulePeriodStore}
          parentsDropdownId={[dropdownId]}
          width={262}
          excludePeriods={excludePeriods}
        />
      </div>
    )
  }
)
